// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
  background: #111 !important;
  padding: 0rem 6rem;
}

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  height: 80px;
  max-height: 100px;
  width: 100%;
  z-index: 900;
  border-radius: 0px !important;
  border-bottom: 1px solid #404040;
  box-shadow: 0 3px 5px 0 rgba(0, 1, 1, 0.1);
}

.right-navlinks {
  border-left: 1px solid #404040;
}

.small-text {
  color: #949494;
  font-size: 15px;
  line-height: 18px;
  font-weight: 300;
}

a.activeLink {
  color: #ffffff !important;
  border-bottom: 3px solid #fff !important;
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0.1) 10%) !important;
}

li {
  list-style: none;
}
li a {
  padding-top: 30px;
  padding-bottom: 35px;
}

.custom-absolute {
  display: none;
}

.logout-dropdown {
  display: none;
  position: absolute;
  bottom: -40px;
  left: 7px;
  background: #111;
  color: white;
  border: 1px solid white;
  padding: 10px 20px;
  border-radius: 20px;
}

.logout-dropdown p {
  margin-bottom: 0px;
}

.logout-dropdown.display {
  display: block;
}

.menu-drop {
  display: none;
  position: absolute;
  top: 46px;
  left: 92px;
  width: 240px;
  border-radius: 16px;
  border: 1px solid;
  background: #fff;
  padding: 16px;
}
.menu-drop .menu-drop-item {
  padding: 5px 0px;
}
.menu-drop .menu-drop-item:hover {
  background: rgba(255, 0, 98, 0.06);
}
.menu-drop .menu-drop-item.sub-active {
  background: rgba(255, 0, 98, 0.06);
}
.menu-drop::after {
  content: "";
  position: absolute;
  top: -20px;
  height: 20px;
  border-top: 4px solid transparent;
  border-left: 11px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #fff;
}

li:hover .menu-drop {
  display: block;
}

.icon {
  display: inline-block;
  height: 20px;
  width: 20px;
  background-size: contain;
  margin-right: 0 !important;
}

.icon-continent {
  background-image: url("/assets/images/ccontinent.svg");
  background-repeat: no-repeat;
}

.icon-pending {
  background-image: url("/assets/images/cpending.svg");
  background-repeat: no-repeat;
}

.icon-pastor {
  background-image: url("/assets/images/cpastor.svg");
  background-repeat: no-repeat;
}

.icon-church {
  background-image: url("/assets/images/cchurch.svg");
  background-repeat: no-repeat;
}

@media screen and (max-width: 767px) {
  .navlinks {
    display: none;
  }
  .navbar {
    padding: 0.5rem 1rem !important;
  }
}
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .navlinks {
    display: none;
  }
  .navbar {
    padding: 0.5rem 2rem !important;
  }
}
/* mobile menu */
@media screen and (max-width: 768px) {
  .custom-absolute.show {
    width: 100%;
    animation-name: slide-in;
  }
  .custom-absolute {
    display: block;
    position: fixed !important;
    background-color: #111;
    left: 0;
    top: 80px;
    height: 100vh;
    width: 0%;
    overflow: hidden;
    transition: all 0.4s ease-in-out;
    animation-duration: 0.4s;
    animation-timing-function: ease;
  }
  @keyframes slide-in {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(0);
    }
  }
  ul {
    margin-top: 30px;
    padding: 0px;
  }
  a.activeLink {
    color: #ffffff !important;
    border-bottom: none !important;
    background: none !important;
  }
  li {
    padding: 10px 20px !important;
  }
  li a {
    padding: 0rem !important;
  }
  .logout-dropdown.display,
  .logout-dropdown {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/navbar/navbar.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,gCAAA;EACA,0CAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,wCAAA;EACA,wFAAA;AACF;;AAMA;EACE,gBAAA;AAHF;AAIE;EACE,iBAAA;EACA,oBAAA;AAFJ;;AAKA;EACE,aAAA;AAFF;;AAIA;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AADF;;AAGA;EACE,kBAAA;AAAF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACE,UAAA;EACF,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;AACF;AACE;EACE,gBAAA;AACJ;AAAI;EACE,kCAAA;AAEN;AAAI;EACE,kCAAA;AAEN;AACE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,8BAAA;AACJ;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,0BAAA;AAAF;;AAGA;EACE,sDAAA;EACA,4BAAA;AAAF;;AAEA;EACE,oDAAA;EACA,4BAAA;AACF;;AACA;EACE,mDAAA;EACA,4BAAA;AAEF;;AAAA;EACE,mDAAA;EACA,4BAAA;AAGF;;AAAA;EACE;IACE,aAAA;EAGF;EAAA;IACE,+BAAA;EAEF;AACF;AACA;EACE;IACE,aAAA;EACF;EAEA;IACE,+BAAA;EAAF;AACF;AAGA,gBAAA;AACA;EAIE;IACE,WAAA;IACA,wBAAA;EAJF;EAMA;IACE,cAAA;IACA,0BAAA;IACA,sBAAA;IACA,OAAA;IACA,SAAA;IACA,aAAA;IACA,SAAA;IACA,gBAAA;IACA,gCAAA;IACA,wBAAA;IACA,+BAAA;EAJF;EAMA;IACE;MACE,4BAAA;IAJF;IAMA;MACE,wBAAA;IAJF;EACF;EAMA;IACE,gBAAA;IACA,YAAA;EAJF;EAMA;IACE,yBAAA;IACA,8BAAA;IACA,2BAAA;EAJF;EAMA;IACE,6BAAA;EAJF;EAMA;IACE,wBAAA;EAJF;EAMA;;IAEE,aAAA;EAJF;AACF","sourcesContent":["nav {\n  background: #111 !important;\n  padding: 0rem 6rem;\n}\n\n.navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 80px;\n  max-height: 100px;\n  width: 100%;\n  z-index: 900;\n  border-radius: 0px !important;\n  border-bottom: 1px solid #404040;\n  box-shadow: 0 3px 5px 0 rgba(0, 1, 1, 0.1);\n}\n\n.right-navlinks {\n  border-left: 1px solid #404040;\n}\n\n.small-text {\n  color: #949494;\n  font-size: 15px;\n  line-height: 18px;\n  font-weight: 300;\n}\n\na.activeLink {\n  color: #ffffff !important;\n  border-bottom: 3px solid #fff !important;\n  background: linear-gradient(\n    180deg,\n    #ffffff 0%,\n    rgba(255, 255, 255, 0.1) 10%\n  ) !important;\n}\n\nli {\n  list-style: none;\n  a {\n    padding-top: 30px;\n    padding-bottom: 35px;\n  }\n}\n.custom-absolute {\n  display: none;\n}\n.logout-dropdown {\n  display: none;\n  position: absolute;\n  bottom: -40px;\n  left: 7px;\n  background: #111;\n  color: white;\n  border: 1px solid white;\n  padding: 10px 20px;\n  border-radius: 20px;\n}\n.logout-dropdown p {\n  margin-bottom: 0px;\n}\n.logout-dropdown.display {\n  display: block;\n}\n\n.menu-drop {\n  display: none;\n  position: absolute;\n  top: 46px;\n    left: 92px;\n  width: 240px;\n  border-radius: 16px;\n  border: 1px solid;\n  background: #fff;\n  padding: 16px;\n\n  .menu-drop-item {\n    padding:5px 0px;\n    &:hover{\n      background:rgb(255, 0, 98, 0.06);\n    }\n    &.sub-active{\n      background:rgb(255, 0, 98, 0.06);\n  }\n  }\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: -20px;\n    height: 20px;\n    border-top: 4px solid transparent;\n    border-left: 11px solid transparent;\n    border-right: 12px solid transparent;\n    border-bottom: 12px solid #fff;\n  }\n}\n\nli:hover .menu-drop {\n  display: block;\n}\n\n.icon{\n  display: inline-block;\n  height: 20px;\n  width: 20px;\n  background-size: contain;\n  margin-right: 0 !important;\n\n}\n.icon-continent{\n  background-image: url('/assets/images/ccontinent.svg');\n  background-repeat: no-repeat;\n}\n.icon-pending{\n  background-image: url('/assets/images/cpending.svg');\n  background-repeat: no-repeat;\n}\n.icon-pastor{\n  background-image: url('/assets/images/cpastor.svg');\n  background-repeat: no-repeat;\n}\n.icon-church{\n  background-image: url('/assets/images/cchurch.svg');\n  background-repeat: no-repeat;\n}\n\n@media screen and (max-width: 767px) {\n  .navlinks {\n    display: none;\n  }\n\n  .navbar {\n    padding: 0.5rem 1rem !important;\n  }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n  .navlinks {\n    display: none;\n  }\n\n  .navbar {\n    padding: 0.5rem 2rem !important;\n  }\n}\n\n/* mobile menu */\n@media screen and (max-width: 768px) {\n  // .custom-relative {\n  //   position: relative;\n  // }\n  .custom-absolute.show {\n    width: 100%;\n    animation-name: slide-in;\n  }\n  .custom-absolute {\n    display: block;\n    position: fixed !important;\n    background-color: #111;\n    left: 0;\n    top: 80px;\n    height: 100vh;\n    width: 0%;\n    overflow: hidden;\n    transition: all 0.4s ease-in-out;\n    animation-duration: 0.4s;\n    animation-timing-function: ease;\n  }\n  @keyframes slide-in {\n    0% {\n      transform: translateX(-100%);\n    }\n    100% {\n      transform: translateX(0);\n    }\n  }\n  ul {\n    margin-top: 30px;\n    padding: 0px;\n  }\n  a.activeLink {\n    color: #ffffff !important;\n    border-bottom: none !important;\n    background: none !important;\n  }\n  li {\n    padding: 10px 20px !important;\n  }\n  li a {\n    padding: 0rem !important;\n  }\n  .logout-dropdown.display,\n  .logout-dropdown {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
